import CalculatedGroup from './layouts/CalculatedGroup.jsx';

export const questionLayouts = {
  CalculatedGroup
};
